/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {Driver} from 'types/entities/Driver'
import {PersonType} from 'types/enums/PersonType'

export const driverName = (driver: Driver, short: boolean = false) => {
    if (typeof driver.last_name === 'undefined' || driver.last_name === null) {
        return driver.username || driver.name
    }
    return driver.username || driver.name + ' ' + (short ? driver.last_name.slice(0, 1) + "." : driver.last_name)
}


export const driverNameInvited = (driver: Driver) => {
    if (typeof driver.last_name === 'undefined' || driver.last_name === null) {
        return driver.username || driver.name
    }
    const lastNameWithFirstDigit = (driver.last_name || '').slice(0, 1) + '.'
    return driver.username || driver.name + ' ' + lastNameWithFirstDigit
}

export const getTextClassNameByPersonType = (personType: PersonType | string) => {
    switch (personType) {
        case PersonType.Adult:
            return 'text-blue-600'
        case PersonType.Child:
            return 'text-green-600'
        default:
            return 'text-gray-600'
    }
}

export const getTextBackgroundClassNameByPersonType = (personType: PersonType | string) => {
    switch (personType) {
        case PersonType.Adult:
            return 'bg-blue-100 text-blue-800'
        case PersonType.Child:
            return 'bg-green-100 text-green-800'
        default:
            return 'bg-gray-100 text-gray-800'
    }
}
